module.exports = __webpack_public_path__ + "media/img/ms-icon-70x70-3bed9703cd7d70015ff49ca4addbdf2c.png";